import React, { useState } from 'react'
import ModalTest from '../../BaseModal'
import * as S from '../../styles/modal-style'
import { X } from 'lucide-react'
import axios from '../../../config/axios'
import { Step } from '../../../pages/ClientPanel/Pipelines/types'

interface PropsInterface {
  closeModal: () => void
  pipelineId: number

}

const AddStepInPipeline:React.FC<PropsInterface> = ({closeModal, pipelineId}) => {
  const [stepName, setStepName] = useState('')

  const handleSaveStep = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_GATEWAY_BASE_URL}/pipelines/step`, {
        name: stepName,
        pipelineId
      })
      if(response.data) {
        closeModal()
      }
    } catch(error) {
      console.error(error) 
    }
  }
  
  return (
    <ModalTest>
      <S.ContainerOfModal>
      <S.Header>
        <S.HeaderTitle>Adicionar campo personalizado</S.HeaderTitle>
          <S.CloseDiv onClick={() => closeModal()}>
            <X size={20} />
          </S.CloseDiv>
        </S.Header>
        <S.FormContainer>
          <S.InputDiv>
            <S.Label>Nome da etapa</S.Label>
            <S.Input placeholder='Digite aqui...' autoFocus value={stepName} onChange={(e) => setStepName(e.target.value)} />
          </S.InputDiv>
        </S.FormContainer>
        <S.BottomDiv>
          <S.ButtonContainer>
            <S.Button onClick={() => closeModal()} className='cancel'>Cancelar</S.Button>
            <S.Button onClick={() => handleSaveStep()}>Salvar</S.Button>
          </S.ButtonContainer>
        </S.BottomDiv>
      </S.ContainerOfModal>
    </ModalTest>
  )
}

export default AddStepInPipeline